var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as R from 'ramda';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import WithRender from './PinInput.html';
// Converts 'abc123' to ['a','b','c','1','2','3']
const toCharArray = R.split('');
// Converts 'abc123' to ['A','B','C','1','2','3']
const toCharArrayUpper = R.compose(R.map(R.toUpper), toCharArray);
// Converts ['a','b','c','1','2','3'] to 'abc123'
const toValue = R.reduce(R.concat, '');
let PinInput = class PinInput extends Vue {
    constructor() {
        super(...arguments);
        this.pin = [];
    }
    get classes() {
        return {
            'PIC--error': this.error,
            'PIC--success': this.success
        };
    }
    get charArray() {
        return new Array(this.length);
    }
    created() {
        const charArray = this.upperCase ? toCharArrayUpper(this.value) : toCharArray(this.value);
        this.pin = !this.disabled && charArray.length === this.length ? charArray : [];
    }
    onInput(i) {
        this.pin[i] = this.upperCase ? R.toUpper(this.pin[i]) : this.pin[i];
        if (this.pin[i] && this.pin[i].length === this.maxlength) {
            this.setFocus(i + 1);
        }
        this.$emit('input', toValue(this.pin));
    }
    onPaste($event, index) {
        if (navigator.clipboard.readText) {
            navigator.clipboard.readText()
                .then((text) => {
                this.pasteClipboardText(text, index);
            })
                .catch((err) => {
                this.$snackbar.error({ message: 'You have denied clipboard permission.' });
            });
        }
        else {
            const clipboardText = $event.clipboardData.getData('text/plain') || '';
            this.pasteClipboardText(clipboardText, index);
        }
    }
    onKeyDown(e, i) {
        this.selectTarget(e);
        const keycode = e.keyCode || e.which;
        if (keycode === 8) {
            this.handleBackspace(e, i);
            return;
        }
        if (keycode === 46) {
            this.handleDelete(e, i);
            return;
        }
        // Move focus backward on left and down arrows
        if (keycode === 37 || keycode === 40) {
            this.setFocus(i - 1);
            return;
        }
        // Move focus forward on right and up arrows
        if (keycode === 38 || keycode === 39) {
            this.setFocus(i + 1);
            return;
        }
        // Emit onEnterPress event
        if (keycode === 13) {
            this.$emit('onEnterKeyPress', this.value);
        }
    }
    selectTarget(e) {
        if (this.maxlength === 1) {
            e.target.select();
        }
    }
    handleBackspace(e, i) {
        if (e.target.value !== '') {
            // If we do this assignment, input event will not fire
            // e.target.value = '';
            this.pin[i] = '';
            return;
        }
        this.setFocus(i - 1);
    }
    handleDelete(e, i) {
        if (e.target.value !== '') {
            // If we do this assignment, input event will not fire
            // e.target.value = '';
            this.pin[i] = '';
            return;
        }
        this.setFocus(i + 1);
    }
    setFocus(i) {
        const inputRef = this.$refs['input' + i];
        if (inputRef) {
            inputRef[0].focus();
        }
    }
    pasteClipboardText(text, index) {
        const pinText = this.upperCase ? toCharArrayUpper(text) : toCharArray(text);
        this.pin = pinText.slice(0, this.length);
        this.setFocus(index);
        this.$emit('input', toValue(this.pin));
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], PinInput.prototype, "length", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], PinInput.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], PinInput.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: 1 }),
    __metadata("design:type", Number)
], PinInput.prototype, "maxlength", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PinInput.prototype, "upperCase", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PinInput.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PinInput.prototype, "readonly", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PinInput.prototype, "success", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], PinInput.prototype, "error", void 0);
PinInput = __decorate([
    WithRender,
    Component({})
], PinInput);
export default PinInput;
//# sourceMappingURL=PinInput.js.map